<script>
import ProductCreate from "@/views/modules/products/ProductCreate.vue";

export default {
  name: "ProductCreatePageEN",
  components: {
    ProductCreate
  }
}
</script>

<template>
  <div>
    <ProductCreate lang="EN" />
  </div>
</template>

<style scoped>
</style>
